import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Wrap *around* a component that needs login
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;                // or spinner
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}
